import { useSelector } from "react-redux";
import currentUserState from "utils/currentUserState";

export function useUser(callback) {
  return useSelector((state) => {
    return callback(currentUserState(state));
  });
}
